/* global BigInt */
export const REFERENCE = 200000000;
export const TIERS = [
  { days: 0, discount: 0, label: "Immediate" },
  { days: 90, discount: 15, label: "90 days" },
  { days: 180, discount: 30, label: "180 days" },
  { days: 540, discount: 60, label: "540 days" },
];
const a = 0.04,
  p = 0.00004,
  e = 0.00009,
  k = 4,
  b = (a * (p + e)) / 2,
  slope = ((1 - a) * (e - p)) / a;
const h = (u) =>
  (u +
    (2 * (Math.exp(-k * u) - 1)) / k -
    (Math.exp(-2 * k * u) - 1) / (2 * k)) /
  (1 - Math.exp(-k)) ** 2;
const amp =
  (250000 / REFERENCE - b - (1 - a) * (e + slope / 2)) / ((1 - a) * h(1));
const endSlope =
  (slope + (amp * 8 * Math.exp(-4)) / (1 - Math.exp(-4))) / (1 - a);
// Display approximation only. Transactions always use exact on-chain integer quotes.
export function price(tokens, tier = 0) {
  const x = tokens / REFERENCE;
  let value;
  if (x <= a) value = p + ((e - p) * x) / a;
  else if (x <= 1) {
    const u = (x - a) / (1 - a);
    value =
      e + slope * u + amp * ((1 - Math.exp(-k * u)) / (1 - Math.exp(-k))) ** 2;
  } else value = e + slope + amp + endSlope * (x - 1);
  return (value * (1 - TIERS[tier].discount / 100)) / 0.4;
}
export function area(tokens, tier = 0) {
  const x = tokens / REFERENCE;
  let value;
  if (x <= a) value = REFERENCE * (p * x + ((e - p) * x * x) / (2 * a));
  else if (x <= 1) {
    const u = (x - a) / (1 - a);
    value =
      REFERENCE * (b + (1 - a) * (e * u + (slope * u * u) / 2 + amp * h(u)));
  } else {
    const z = x - 1;
    value =
      250000 + REFERENCE * ((e + slope + amp) * z + (endSlope * z * z) / 2);
  }
  return (value * (1 - TIERS[tier].discount / 100)) / 0.4;
}
export function parseAmount(value, decimals = 18) {
  if (!/^\d+(\.\d*)?$/.test(value))
    throw new Error("Enter a positive number without commas.");
  const [whole, fraction = ""] = value.split(".");
  if (fraction.length > decimals)
    throw new Error(`Use no more than ${decimals} decimal places.`);
  const result =
    BigInt(whole) * 10n ** BigInt(decimals) +
    BigInt(fraction.padEnd(decimals, "0") || "0");
  if (result <= 0n) throw new Error("Enter an amount greater than zero.");
  return result;
}
export const human = (raw, decimals = 18) => Number(raw) / 10 ** decimals;
export const number = (value, digits = 2) =>
  Number(value).toLocaleString("en-US", { maximumFractionDigits: digits });
export const rawText = (raw, decimals = 18) => {
  const s = BigInt(raw)
    .toString()
    .padStart(decimals + 1, "0");
  return `${s.slice(0, -decimals)}.${s.slice(-decimals)}`.replace(/\.?0+$/, "");
};
export function scanOwnedEvents(events, account, initialIds = []) {
  const ids = new Set(initialIds);
  events
    .sort(
      (a, b) =>
        Number(BigInt(a.blockNumber) - BigInt(b.blockNumber)) ||
        Number(BigInt(a.logIndex) - BigInt(b.logIndex)),
    )
    .forEach((event) => {
      const { from, to, tokenId } = event.returnValues;
      if (from.toLowerCase() === account.toLowerCase())
        ids.delete(tokenId.toString());
      if (to.toLowerCase() === account.toLowerCase())
        ids.add(tokenId.toString());
    });
  return [...ids];
}
